import { datadogRum } from '@datadog/browser-rum';
import { environment } from 'src/environments/environment';

const sanitizeDatadogTag = (value?: string): string | undefined => {
	if (!value) {
		return undefined;
	}

	return value
		.toLowerCase()
		.replace(/[^a-z0-9_:\/.-]+/g, '-')
		.replace(/^-+|-+$/g, '');
};

export const initializeDatadogRum = () => {
	// Initialize Datadog RUM
	datadogRum.init({
		applicationId: environment.datadog?.applicationId,
		clientToken: environment.datadog?.clientToken,
		site: environment.datadog?.site,
		service: sanitizeDatadogTag(environment.datadog?.service),
		env: sanitizeDatadogTag(environment.datadog?.env),

		// Specify a version number to identify the deployed version of your application in Datadog
		version: '2.0.0-20230623',
		sampleRate: 45,
		sessionReplaySampleRate: 20,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: 'mask-user-input',
		useSecureSessionCookie:true,
	});

	datadogRum.startSessionReplayRecording();
};
